const VoyagePhysicalOceanList = () => import('Views/voyage/voyagePhysicalOcean/voyage-list');
const VoyagePhysicalOceanDetail = () => import('Views/voyage/voyagePhysicalOcean/voyage-detail');
const VoyagePhysicalOceanFileDetail = () => import('Views/voyage/voyagePhysicalOcean/voyage-file-detail');
const VoyageOfflineAudit = () => import('Views/voyage/voyageOfflineAudit/voyage-offline-audit');
const VoyageDataDirList = () => import('Views/voyage/voyage-data-dir/voyage-data-dir-list');

export default[
  { path: '/voyage-geophysics-list', component: VoyagePhysicalOceanList },
  { path: '/voyage-data-dir-list/:id', component: VoyageDataDirList },
  { path: '/voyage-geophysics-detail/:id', component: VoyagePhysicalOceanDetail },
  { path: '/voyage-offline-audit/:id', component: VoyageOfflineAudit },
  { path: '/voyage-file/detail/:id', component: VoyagePhysicalOceanFileDetail },
];



// WEBPACK FOOTER //
// ./src/router/voyagePhysicalOcean.js